import React from 'react';
import {
  Accordion,
  AccordionSummary,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import keyBy from 'lodash/keyBy';

export const ListItems = (props) => {
  const getItemIds = (items) => items.map((item) => item.id);
  const itemsIds = getItemIds(props.order.items);

  const uniqueArray = (arr) => [...new Set(arr)];
  const getIdenticalItems = (array, value) => array.filter((v) => v === value);

  const uniqueItemsIds = uniqueArray(itemsIds);
  const uniqueArrayItems = keyBy(props.order.items, 'id');
  const areTokensRedeeemed =
      Object.keys(props.order.tokens_redeemed || {}).length > 0;

  return (
      props.order.items && (
          <Accordion defaultExpanded={props.defaultExpand !== false}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
              <Typography variant="h6" gutterBottom>
                Items
              </Typography>
            </AccordionSummary>
            <Paper sx={{ width: '100%', overflowX: 'auto' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>Price</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>Quantity</TableCell>
                    {areTokensRedeeemed && (
                        <TableCell sx={{ textAlign: 'right' }}>
                          Tokens Redeemed
                        </TableCell>
                    )}
                    <TableCell sx={{ textAlign: 'right' }}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {uniqueItemsIds.map((itemId) => {
                    const item = uniqueArrayItems[itemId];
                    const identicalItems = getIdenticalItems(itemsIds, item.id);
                    const itemQuantity = identicalItems.length;
                    const tokensRedeemed = props.order.items.filter(
                        (t) => t.redeemed_token_id
                    ).length;

                    const itemTotal =
                        ((itemQuantity - tokensRedeemed) * item.price) / 100;

                    return (
                        <TableRow key={item.id}>
                          <TableCell>{item.name}</TableCell>
                          <TableCell sx={{ textAlign: 'right' }}>
                            {`$ ${(item.price / 100).toFixed(2)}`}
                          </TableCell>
                          <TableCell sx={{ textAlign: 'right' }}>
                            {itemQuantity}
                          </TableCell>
                          {areTokensRedeeemed && (
                              <TableCell sx={{ textAlign: 'right' }}>
                                {tokensRedeemed}
                              </TableCell>
                          )}
                          <TableCell sx={{ textAlign: 'right' }}>
                            {`$ ${itemTotal.toFixed(2)}`}
                          </TableCell>
                        </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Paper>
          </Accordion>
      )
  );
};
